export const config = {
  src: [
    'audiosprites/audio.ogg',
    'audiosprites/audio.mp3',
  ],
  sprite: {
    big_win: [
      0,
      2848.798185941043,
    ],
    button_spin: [
      4000,
      384.5804988662129,
    ],
    free_bet_big_win: [
      6000,
      1377.2335600907031,
    ],
    free_bet_mega_win: [
      9000,
      2213.151927437641,
    ],
    free_bet_total_win: [
      13000,
      979.5918367346932,
    ],
    free_bet_ultra_win: [
      15000,
      1319.1836734693893,
    ],
    inside_buttons: [
      18000,
      143.67346938775682,
    ],
    main_ambient: [
      20000,
      62035.011337868484,
    ],
    mega_win: [
      84000,
      2944.580498866216,
    ],
    outside_buttons: [
      88000,
      219.1383219954588,
    ],
    reel_spin: [
      90000,
      1603.6281179138286,
    ],
    reel_stop_01: [
      93000,
      210.4308390022709,
    ],
    reel_stop_02: [
      95000,
      219.1383219954588,
    ],
    reel_stop_03: [
      97000,
      236.55328798186304,
    ],
    reel_stop_04: [
      99000,
      207.5283446712035,
    ],
    reel_stop_05: [
      101000,
      262.6757369614552,
    ],
    regular_win: [
      103000,
      767.709750566894,
    ],
    tap_to_play: [
      105000,
      1005.7142857142907,
    ],
    ultra_win: [
      108000,
      3078.095238095244,
    ],
    x2_win: [
      113000,
      1609.4331065759634,
    ],
  },
}
